var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilialen = function SvgFilialen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "filialen_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 756 551"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".filialen_svg__st7{fill:#a9989d}.filialen_svg__st8{fill:#b8bcbf}.filialen_svg__st9{fill:#f9f2f8}.filialen_svg__st11{fill:#d8dbdc}.filialen_svg__st12{fill:#edeff0}.filialen_svg__st15{fill:#e4cec1}.filialen_svg__st16{fill:#e2e5e6}.filialen_svg__st18{fill:#f3eeed}.filialen_svg__st19{fill:#868285}.filialen_svg__st20{fill:#fff}.filialen_svg__st21{fill:#78645d}.filialen_svg__st23{fill:#505e5f}.filialen_svg__st24{fill:#86b7de}.filialen_svg__st27{fill:#2e3535}.filialen_svg__st28{fill:#414c4c}.filialen_svg__st30{fill:#4691ce}.filialen_svg__st31{fill:#c7dcee}.filialen_svg__st32{fill:#e7eff6}.filialen_svg__st33{fill:#a7c9e6}.filialen_svg__st43{fill:#66a4d6}.filialen_svg__st44{fill:#cdd0d3}")), /*#__PURE__*/React.createElement("circle", {
    cx: 302.9,
    cy: 238.5,
    r: 214.9,
    style: {
      fill: "#fcf8cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.9 476.9c-4.5 0-9.1-.1-13.6-.4l.1-2.2c4.5.3 9 .4 13.5.4h.5v2.2zm14.1-.4-.1-2.2c4.5-.3 9-.7 13.4-1.2l.3 2.2c-4.5.6-9.1 1-13.6 1.2m-41.3-1.1c-4.5-.5-9-1.2-13.5-1.9l.4-2.2c4.4.8 8.9 1.4 13.3 1.9zm68.3-2-.4-2.2c4.4-.8 8.9-1.7 13.2-2.7l.5 2.2c-4.3 1-8.8 1.9-13.3 2.7m-95.1-2.6c-4.4-1-8.8-2.2-13.2-3.5l.6-2.2c4.3 1.3 8.7 2.4 13 3.4zm121.6-3.6-.6-2.2c4.3-1.3 8.6-2.7 12.8-4.2l.8 2.1c-4.3 1.6-8.7 3-13 4.3m-147.7-4.1c-4.3-1.5-8.5-3.2-12.7-5l.9-2.1c4.1 1.8 8.4 3.4 12.6 4.9zm173.3-5.1-.9-2.1c4.1-1.8 8.2-3.6 12.2-5.6l1 2c-4 2-8.2 3.9-12.3 5.7m-198.4-5.6c-4.1-2-8.1-4.2-12-6.4l1.1-2c3.9 2.2 7.9 4.3 11.9 6.3zm222.7-6.5-1.1-1.9c3.9-2.2 7.8-4.6 11.5-7l1.2 1.9c-3.7 2.4-7.6 4.8-11.6 7M174 439c-3.8-2.4-7.6-5-11.2-7.7l1.3-1.8c3.6 2.6 7.4 5.2 11.1 7.6zm269.3-7.9-1.3-1.8c3.6-2.6 7.2-5.4 10.7-8.3l1.4 1.7q-5.4 4.5-10.8 8.4M152 423c-3.5-2.9-7-5.9-10.3-8.9l1.5-1.7c3.3 3 6.7 6 10.2 8.8zm312.3-9.1-1.5-1.7c3.3-3 6.5-6.2 9.7-9.4l1.6 1.6c-3.2 3.2-6.5 6.4-9.8 9.5m-332.4-9.3c-3.1-3.2-6.2-6.6-9.2-10l1.7-1.5c2.9 3.4 6 6.7 9.1 9.9zm351.3-10.3-1.7-1.5c2.9-3.4 5.8-6.9 8.5-10.4l1.8 1.4c-2.7 3.5-5.6 7.1-8.6 10.5M114.1 384c-2.8-3.6-5.5-7.3-8-11l1.8-1.3c2.5 3.7 5.2 7.4 7.9 10.9zm385.8-11.3-1.9-1.3c2.5-3.7 5-7.5 7.3-11.4l1.9 1.2c-2.3 4-4.8 7.8-7.3 11.5M98.7 361.6c-2.3-3.9-4.6-7.8-6.7-11.8l2-1c2.1 3.9 4.3 7.9 6.6 11.7zm415.2-12.2-2-1c2.1-4 4.1-8 6-12.1l2 .9c-1.8 4.1-3.9 8.2-6 12.2M86 337.6c-1.9-4.1-3.7-8.3-5.3-12.5l2.1-.8c1.6 4.2 3.4 8.3 5.3 12.4zm439.3-13-2.1-.8c1.6-4.2 3.2-8.5 4.5-12.7l2.1.7c-1.4 4.3-2.9 8.6-4.5 12.8M76.1 312.2c-1.4-4.3-2.7-8.7-3.8-13.1l2.2-.6c1.1 4.3 2.4 8.7 3.8 12.9zm457.5-13.5-2.2-.6c1.1-4.3 2.2-8.8 3-13.1l2.2.4c-.8 4.5-1.8 8.9-3 13.3M69.2 285.9c-.9-4.4-1.7-8.9-2.3-13.4l2.2-.3c.6 4.4 1.4 8.9 2.3 13.3zM539 272l-2.2-.3c.6-4.4 1.1-8.9 1.5-13.4l2.2.2c-.4 4.5-.9 9.1-1.5 13.5M65.3 259c-.4-4.5-.6-9.1-.8-13.6l2.2-.1c.1 4.5.4 9 .8 13.5zm476-14.1-2.2-.1c.1-2.1.1-4.3.1-6.4 0-2.4 0-4.7-.1-7.1l2.2-.1c.1 2.4.1 4.8.1 7.2 0 2.2-.1 4.4-.1 6.5M66.7 231.8l-2.2-.1c.1-4.5.4-9.1.8-13.6l2.2.2c-.4 4.5-.6 9.1-.8 13.5m471.5-13.9c-.4-4.5-.9-9-1.5-13.4l2.2-.3c.6 4.5 1.2 9 1.6 13.5zM69 205l-2.2-.3c.6-4.5 1.4-9 2.3-13.4l2.2.4c-.9 4.4-1.6 8.8-2.3 13.3m465.4-13.8c-.9-4.4-1.9-8.8-3.1-13.1l2.2-.6c1.2 4.4 2.2 8.8 3.1 13.3zm-460-12.6-2.2-.6c1.1-4.4 2.4-8.8 3.8-13.1l2.1.7c-1.3 4.3-2.6 8.6-3.7 13m453.1-13.4c-1.4-4.2-2.9-8.5-4.6-12.7l2.1-.8c1.7 4.2 3.2 8.5 4.6 12.8zM82.7 152.9l-2.1-.8c1.6-4.2 3.4-8.4 5.3-12.6l2 .9c-1.8 4.1-3.6 8.3-5.2 12.5m434.9-12.8c-1.9-4.1-3.9-8.1-6-12.1l2-1.1c2.1 4 4.1 8.1 6 12.2zM93.9 128.3l-2-1c2.1-4 4.4-8 6.7-11.9l1.9 1.2c-2.2 3.8-4.5 7.8-6.6 11.7m411.1-12c-2.3-3.8-4.8-7.6-7.3-11.3l1.8-1.3c2.6 3.7 5 7.6 7.4 11.4zm-397.1-11L106 104c2.6-3.7 5.2-7.4 8-11l1.8 1.4c-2.7 3.5-5.4 7.2-7.9 10.9m381.8-11.2c-2.7-3.5-5.6-7-8.6-10.4l1.7-1.5c3 3.4 5.9 7 8.6 10.5zM124.4 83.9l-1.7-1.5c3-3.4 6.1-6.8 9.2-10l1.6 1.6c-3.1 3.2-6.2 6.5-9.1 9.9m347.7-10.1c-3.1-3.2-6.4-6.4-9.7-9.4l1.5-1.7c3.3 3.1 6.6 6.2 9.8 9.5zm-328.9-9.2-1.5-1.7c3.3-3.1 6.8-6.1 10.3-8.9l1.4 1.7c-3.5 2.9-6.9 5.8-10.2 8.9m309-9.1c-3.5-2.8-7.1-5.6-10.7-8.2l1.3-1.8c3.7 2.7 7.3 5.5 10.8 8.3zm-288.2-8-1.3-1.8c3.6-2.7 7.4-5.3 11.2-7.7l1.2 1.9c-3.7 2.4-7.5 4.9-11.1 7.6m266.4-7.8c-3.8-2.4-7.7-4.8-11.6-7l1.1-2c3.9 2.2 7.9 4.6 11.7 7zm-243.8-6.8-1.1-2c3.9-2.2 8-4.4 12-6.4l1 2c-4 2-8 4.2-11.9 6.4m220.3-6.5c-4-2-8.1-3.9-12.3-5.6l.9-2.1c4.2 1.8 8.3 3.7 12.4 5.7zm-196.1-5.5-.9-2.1c4.2-1.8 8.4-3.4 12.7-5l.8 2.1c-4.3 1.6-8.5 3.3-12.6 5m171.2-5q-6.3-2.25-12.9-4.2l.6-2.2c4.3 1.3 8.7 2.7 13 4.2zm-145.9-4.1-.6-2.2c4.3-1.3 8.8-2.4 13.2-3.5l.5 2.2c-4.4 1.1-8.8 2.3-13.1 3.5m120-3.5q-6.6-1.5-13.2-2.7l.4-2.2c4.5.8 8.9 1.7 13.3 2.7zm-93.7-2.6-.4-2.2c4.5-.8 9-1.4 13.5-1.9l.3 2.2c-4.5.5-9 1.2-13.4 1.9m67.1-2c-4.4-.5-9-.9-13.4-1.1l.1-2.2c4.5.3 9.1.6 13.6 1.1zm-40.3-1.1L289 .4c4.5-.3 9.1-.4 13.6-.4v2.2c-4.4 0-9 .2-13.4.4",
    style: {
      fill: "#f5e663"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_1_",
    x1: 196.042,
    x2: 755.646,
    y1: 267.904,
    y2: 267.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    style: {
      stopColor: "#fde9ce"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#fdedd7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    style: {
      stopColor: "#fef7ed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#fffdfa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M755.6 315.6 559.2 429.8 196 220.2 392.6 106z",
    style: {
      fill: "url(#filialen_svg__SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_2_",
    x1: 332.423,
    x2: 237.414,
    y1: 296.251,
    y2: 463.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#263739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    style: {
      stopColor: "#616e6f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    style: {
      stopColor: "#99a1a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    style: {
      stopColor: "#c5caca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#e5e7e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    style: {
      stopColor: "#f8f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M559.6 436.6 363.2 550.8 0 341.2 196.6 227z",
    style: {
      fill: "url(#filialen_svg__SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_3_",
    x1: 655.308,
    x2: 639.714,
    y1: 371.851,
    y2: 343.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m579.5 411.9 162.3-94.3-27.2-15.9L552.4 396z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_4_",
    x1: 541.114,
    x2: 678.451,
    y1: 443.14,
    y2: 363.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e4c3a9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3a9",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M755.6 315.6v6.7L559.2 436.5v-6.7z",
    style: {
      fill: "url(#filialen_svg__SVGID_4_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.2 429.8v6.7L196 226.9v-6.7z",
    style: {
      fill: "#efdbcb"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M546 311v14.6h-.1z",
    className: "filialen_svg__st7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m728.3 228.2-.2 81.5L565.8 404l.2-81.5h.1z",
    className: "filialen_svg__st8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M546 311v14.6h-.1z",
    className: "filialen_svg__st7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546.2 244.1",
    className: "filialen_svg__st9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.5 210.5v.1l-.1 44.7-.1 36.7-14 8.1.1-16.2v-20.5l.2-44.8v-.1l13.8-8 .1-.1z",
    style: {
      fill: "#96898c"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m363.6 218.6-.2 44.8v20.5l-.1 16.2-125-72.2.2-81.5 107.4 62z",
    className: "filialen_svg__st11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M491.3 219.1v12.5l-81-46.8-12.9-7.4-10.6-6.1-40.7-23.5v-12.5l25.1 14.4.3.3 13.2 7.5 10.5 6.1 12.9 7.4z",
    className: "filialen_svg__st12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m491.3 231.6-.1 32.2-2.7 1.6-.1 9.1v3.2l-.1 14.6-.2 63.6L377.3 292l.1-36.7.1-44.7v-.2h.1v-12.2l-21-12.2-10.5-6-.1 12.2v-27.9l.1-16.5 40.7 23.5 10.6 6.1 12.9 7.4z",
    style: {
      fill: "#ab927f"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_5_",
    x1: 400.943,
    x2: 377.728,
    y1: 253.709,
    y2: 256.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m386.1 217.7-2.5 1.1-6-20.6-.3 93.8 32.7 18.8z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_5_)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m566 322.5-.2 81.6-77.7-44.9V356l.2-63.7.1-14.6 2.8 1.6L546 311z",
    className: "filialen_svg__st11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m238.6 146.3 125 72.2v.1l-17.7-10.2-107.4-62zM377.5 210.4l-.1.1zM546.2 231.8h.1l-.1.1z",
    className: "filialen_svg__st15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m701.5 216-10.5 6.1-122.1 71-40.2-23.2-10.5-6.1 55-32-26.9-15.5v-29.1l-12.7-7.4-25.2 14.6-94.6-54.6.1-29.1-12.8-7.4-55 32-.1 29-14 8.2-56-32.3-10.5-6.1 146.6-85.2z",
    className: "filialen_svg__st11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m491.2 276.2-.1-.1h.1zM488.4 277.7l77.7 44.8h-.1L546 311l-54.8-31.7z",
    className: "filialen_svg__st15"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M412.1 48.9v12.2L276 140.2l-10.5-6.1z",
    className: "filialen_svg__st16"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m363.7 206.3-.1 12.2-125-72.2v-12.2l10.5 6.1z",
    className: "filialen_svg__st12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.5 210.5h-.1l.1-.1z",
    style: {
      fill: "#c0bbbf"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m701.5 216-10.5 6.1-278.9-161V48.9z",
    className: "filialen_svg__st12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m508.4 194.4-13.4 7.8-3.7 2.2-77.5-44.8v-19.8z",
    className: "filialen_svg__st18"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m546.3 231.8-.1.1v-.1z",
    className: "filialen_svg__st19"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m573.2 231.8-.1 12.3-44.4 25.8-10.5-6.1z",
    className: "filialen_svg__st16"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m490.6 278.9-2.1-1.2zl53.5 31z",
    className: "filialen_svg__st19"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m499.1 271.6-.1-.1-7.8-4.5-2.8-1.6v12.2l2.1 1.2 53.6 30.9 22 12.7v-12.2zm-7.9 4.5v.1z",
    className: "filialen_svg__st12"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M491.2 276.1v.1l-.1-.1zM566.1 322.5",
    className: "filialen_svg__st19"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M728.4 216v12.2h-.1l-162.2 94.3v-12.2l151.7-88.1zM728.3 228.2l-162.2 94.3z",
    className: "filialen_svg__st16"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M546.2 244.1",
    className: "filialen_svg__st18"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M412 33.3 238.6 134.1l10.5 6.1 114.5 66.1 3.2-1.9.1-.1 10.6-6.2-21-12.2-10.5-6.1v-15.6l-14 8.2-56-32.3-10.5-6.1 146.6-85.2L701.5 216l-10.6 6.2-122.1 70.9-40.2-23.2-10.5-6.1 55-32-26.9-15.5v15.5h.1-.1l-10.5 6.1h-.1l-44.4 25.8-2.8 1.6 2.8 1.6 7.8 4.5.1.1 67 38.7 151.6-88.1 10.6-6.2zm134.2 210.8",
    className: "filialen_svg__st20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413.9 110.7v11.8l-32.2 18.6-10.1-5.8z",
    className: "filialen_svg__st16"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m413.9 122.5-.1 17.3v19.8l-12.7-7.3-3.8-2.1-13.4-7.8-2.2-1.3z",
    className: "filialen_svg__st21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m533.6 179.8-25.2 14.6-13.4 7.8-3.7 2.2-77.5-44.7-12.7-7.3-3.7-2.1-13.5-7.8-12.3-7.1 42.3-24.6-12.8-7.4-55 32 25 14.5.4.2 13.1 7.6 10.5 6.1 12.9 7.4 83.3 48.1 5.8-3.4h.1l10.6-6.1 13.4-7.8 25.2-14.6zM401 160.3",
    className: "filialen_svg__st20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M401 160.3",
    className: "filialen_svg__st9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M546.3 187.2v12.4l-25.2 14.7-13.4 7.7-10.6 6.2-5.8 3.4v-12.5l5.8-3.3.1-.1 10.6-6.1 13.3-7.8z",
    className: "filialen_svg__st16"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M546.3 199.6v16.7l-.1 15.5v.1l-10.5 6.1-44.5 25.8.1-32.2 5.8-3.4 10.6-6.2 13.4-7.7z",
    className: "filialen_svg__st21"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M377.6 198.2v12.2l-.1.1v-.1l-.1.1-13.8 8 .1-12.2 3.2-1.9h.1z",
    className: "filialen_svg__st16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.5 210.4v.2l-.1-.1z",
    style: {
      fill: "#9f653e"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m377.9 222.4-.2 69.3-14.3 8.3.2-69.3z",
    className: "filialen_svg__st23"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m365.6 231.8 10.3-6-.2 64.7-10.3 6z",
    className: "filialen_svg__st24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_6_",
    x1: 354.883,
    x2: 372.017,
    y1: 277.916,
    y2: 259.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m377.9 222.4-.2 69.3-14.3 8.3.2-69.3z",
    style: {
      fill: "url(#filialen_svg__SVGID_6_)"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m260.2 171-.2 69.3L363.4 300l.2-69.3zm16.6 76.7-14.8-8.6.2-64.7L277 183zm16.9 9.7-14.9-8.6.2-64.7 14.9 8.6zm16.9 9.8-14.9-8.6.2-64.7 14.9 8.6zm16.9 9.8-14.9-8.6.2-64.7 14.9 8.6zm2.2-63.6 14.9 8.6-.2 64.7-14.9-8.6zm31.7 83.1-14.9-8.6.2-64.7 15 8.6z",
    className: "filialen_svg__st23"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m277 183-.2 64.7-14.8-8.6.2-64.7zM293.9 192.8l-.2 64.6-14.9-8.6.2-64.7zM310.8 202.5l-.2 64.7-14.9-8.6.2-64.7zM327.7 212.3l-.2 64.7-14.9-8.6.2-64.7zM344.6 222l-.1 64.7-15-8.6.2-64.7zM361.6 231.8l-.2 64.7-14.9-8.6.1-64.7z",
    className: "filialen_svg__st24"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m491.2 279.3-2.8-1.6v14.6l-.2 63.6v3.3l56 32.3v-81.6zm50.9 108.8-16-9.2.2-74.2h-2l-.2 73.1-15.9-9.2.2-72h-2l-.2 70.8-16.1-9.3.2-76.9 51.8 29.9z",
    className: "filialen_svg__st23"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M542.1 311.1v77l-15.9-9.3.1-74.2h-2l-.1 73.1-16-9.2.2-72h-2l-.2 70.8-16.1-9.2.3-76.9z",
    className: "filialen_svg__st24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_7_",
    x1: 513.915,
    x2: 523.418,
    y1: 323.396,
    y2: 307.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m544.1 312.2 10.7 28.7-66.5-38.5v-21.7z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_7_)"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m386.1 215.3-22.4 13-111.6-64.4 8.5-4.9 103.1 59.5 13.9-8.1z",
    className: "filialen_svg__st23"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M386.1 215.3v2.4l-22.4 13.1v-2.5z",
    className: "filialen_svg__st27"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M363.7 228.3v2.5l-111.6-64.4v-2.5z",
    className: "filialen_svg__st28"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m544.1 309.8-8.4 4.9-64.2-37.1 11.3-6.5 5.6 3.3v3.3h.1l2 1.2z",
    className: "filialen_svg__st23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m544.1 309.8-53.6-30.9-2-1.2v-.1l2.1 1.3z",
    style: {
      fill: "#504d56"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M544.1 309.8v2.4l-8.4 5v-2.5z",
    className: "filialen_svg__st27"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M535.7 314.7v2.5l-64.2-37.1v-2.5z",
    className: "filialen_svg__st28"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m453.1 274.9-.2 60.7-49.5-28.6.1-60.7 24.5 14.1-.2 60.7.7.4.2-60.7z",
    className: "filialen_svg__st24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m456 273.3-.2 64-2.9-1.7.2-60.7-24.4-14.1-.2 60.7-.7-.4.2-60.7-24.5-14.1-.1 60.7-2.9-1.6.2-64z",
    className: "filialen_svg__st23"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M431.4 215.3c20.9 12 37.8 28.1 37.7 35.9 0 7.8-17 4.3-37.8-7.7-20.9-12-37.8-28.1-37.7-35.9 0-7.8 17-4.3 37.8 7.7",
    className: "filialen_svg__st30"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m524.2 338.2-15.9-16.4v15.8l15.9 16.4z",
    className: "filialen_svg__st31"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m490.2 319 16.1 16.5v-15.7l-16-16.5z",
    className: "filialen_svg__st32"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m542.1 356.6-15.9-16.3V356l15.9 16.4zM453 306.5l-24.4-25v15.7l24.4 25.1z",
    className: "filialen_svg__st33"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M403.5 255.7v15.7l24.4 25.1v-15.8z",
    className: "filialen_svg__st31"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m346.5 279.3 14.9 15.3.1-15.7-15-15.3zM329.6 261.9l14.9 15.4v-15.8l-14.9-15.3z",
    className: "filialen_svg__st33"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m312.7 244.6 14.9 15.3v-15.7l-14.9-15.4zM295.8 227.2l14.9 15.3v-15.7l-14.9-15.3z",
    className: "filialen_svg__st31"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m278.9 209.8 14.9 15.4.1-15.8-14.9-15.3zM262.1 192.6l14.8 15.2.1-15.7-14.9-15.3z",
    className: "filialen_svg__st32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_8_",
    x1: 400.979,
    x2: 400.969,
    y1: 160.251,
    y2: 160.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401 160.3",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_8_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_9_",
    x1: 458.37,
    x2: 447.342,
    y1: 162.645,
    y2: 182.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m401.1 152.3 12.7 7.3 77.5 44.8 3.7-2.2 13.4-7.8-76.9-44.4-34 .2z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_9_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_10_",
    x1: 552.639,
    x2: 538.488,
    y1: 217.39,
    y2: 236.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m547 216.8-.7-.5-.1 15.5v.1l-10.5 6.1-44.5 25.8 79.5-33.4z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_10_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_11_",
    x1: 557.051,
    x2: 500.588,
    y1: 156.182,
    y2: 257.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m471.8 173.3 36.6 21.1 25.2-14.6 12.7 7.4-25.2 14.6 10.8 6.2 14.4-8.4v16.7l26.9 15.5-.1 12.3-44.4 25.8 114.6-38.3-166.4-96.1-45 14.7z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_11_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_12_",
    x1: 301.962,
    x2: 313.592,
    y1: 222.323,
    y2: 195.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.7 229.6v21.6l-111.6-84.8z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_12_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_13_",
    x1: 351.307,
    x2: 345.83,
    y1: 109.459,
    y2: 100.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.1 61.1 276 140.2l-3.6-2.1 3.6 2.1 9.1 5.2 136.8-78.6z",
    style: {
      fill: "url(#filialen_svg__SVGID_13_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_14_",
    x1: 449.519,
    x2: 370.606,
    y1: 343.051,
    y2: 294.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455.8 337.3 377.3 292l-13.9 8.1 78.5 45.3z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_14_)"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M214.2 249.9 155.6 284l-3.5-2.1 58.5-34zM252.2 271.9l-58.6 34-3.5-2 58.5-34.1zM290.1 293.8l-58.5 34-3.6-2 58.6-34zM518 425.4l-58.5 34-3.6-2 58.6-34.1zM480.1 403.5l-58.6 34-3.5-2.1 58.5-34zM442.1 381.5l-58.6 34.1-3.5-2.1 58.5-34zM404.1 359.6l-58.6 34-3.5-2 58.5-34.1zM366.1 337.7l-58.5 34-3.6-2 58.6-34.1zM328.1 315.7l-58.5 34.1-3.6-2.1 58.6-34z",
    className: "filialen_svg__st20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "filialen_svg__SVGID_15_",
    x1: 367.925,
    x2: 202.995,
    y1: 447.609,
    y2: 336.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m377.3 408.5-66.9 38.9-67.4-38.9 29.9-17.4L170.6 332l7-4.1L280 387l29.9-17.4z",
    style: {
      opacity: 0.2,
      fill: "url(#filialen_svg__SVGID_15_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.2 227.6-5.6 3.3-5.7-3.3 5.6-3.3z",
    style: {
      fill: "#c7ced4"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m182.2 227.6-.3 104.3-5.6 3.3.3-104.3z",
    className: "filialen_svg__st8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m176.6 230.9-.3 104.3-5.7-3.3.3-104.3z",
    className: "filialen_svg__st11"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m176 185.4.5.3v.4l-.5-.2z",
    className: "filialen_svg__st24"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m176.2 128.6-49.1 28.5 5.9 3.4 43.1 24.9.5.3 43.2-25.1 5.9-3.4zm.3 53.7-.4-.2-43.1-24.9 43.2-25.1 43.5 25.1z",
    className: "filialen_svg__st33"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m176.2 132-.1 50-43.1-24.8z",
    className: "filialen_svg__st30"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m219.7 157.2-43.2 25.1-.4-.3.1-50zM225.6 157.2l-.1 53.8-49.1 28.5.1-53.4v-.4l43.2-25.1z",
    className: "filialen_svg__st43"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m176.5 186.1-.1 53.4-49.5-28.5.2-53.8 5.9 3.4 43 24.8v.5z",
    className: "filialen_svg__st24"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 185.7v.4l-.5-.2v-.5z",
    className: "filialen_svg__st24"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M203.2 156.9v9.9l-26.7 15.5-.3-.2.1-9.5z",
    className: "filialen_svg__st8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m176.3 172.6-.1 9.5-.1-.1-27-15.5v-9.6z",
    className: "filialen_svg__st11"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m203.2 156.9-26.9 15.7-27.2-15.7 27-15.7z",
    className: "filialen_svg__st32"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M143.6 209.1s-.1 0-.1.1c0-.1.1-.1.1-.1M143.8 209c-.1 0-.1.1-.2.1.1-.1.1-.1.2-.1M144 209c-.1 0-.2 0-.2.1 0-.1.1-.1.2-.1M144.2 208.9h-.2zM144.3 208.9h-.2zM144.4 208.9h-.1zM147 208h-.1zM147.1 208h-.1zM147.3 208.1h-.1c0-.1 0 0 .1 0M147.3 208.1",
    className: "filialen_svg__st24"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M148.8 214.6v.6c0 .1 0 .1-.1.2 0 .1 0 .1-.1.2 0 0 0 .1-.1.1 0 .1-.1.1-.1.2s-.1.1-.2.2l-.1.1-.1.1-.1.1c-.5.3-1.1.3-1.7 0-.2-.1-.3-.2-.5-.2-1.5-.9-2.8-2.9-3.1-4.8-.2-1.3.2-2.2.9-2.6 0 0 .1 0 .1-.1.1 0 .1-.1.2-.1h1.3c.1 0 .1.1.2.1s.1.1.2.1l.1.1s.1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.2.2c0 .1.1.1.1.2.1.1.1.2.2.3s.2.3.3.4c0 .1.1.2.1.3s.1.1.1.2.1.1.1.2 0 .1.1.2c0 0 0 .1.1.1 0 .1 0 .1.1.1 0 .1 0 .1.1.2 0 .1 0 .1.1.2v1.7c.7.4.7.5.7.5",
    className: "filialen_svg__st20"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M148.8 214.3v-.2zM148.8 214.5v-.1zM148.8 214.6v-.1zM148.8 214.6v.1z",
    className: "filialen_svg__st24"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M150.7 213.7v.8c0 .1 0 .1-.1.2 0 .1 0 .1-.1.2 0 .1-.1.1-.1.2-.1.2-.3.4-.5.5l-1.8 1.1.1-.1.1-.1.1-.1.2-.2c0-.1.1-.1.1-.2 0 0 0-.1.1-.1 0-.1 0-.1.1-.2v-2.8c0-.1 0-.1-.1-.2 0 0 0-.1-.1-.2 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1 0-.1-.1-.2 0-.1 0-.1-.1-.2 0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c-.1-.1-.2-.3-.3-.4s-.1-.2-.2-.3c0-.1-.1-.1-.1-.2l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1l-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1h-.1s-.1 0-.1-.1h-1.3c-.1 0-.1 0-.2.1l1.8-1c.1 0 .2-.1.3-.1s.1 0 .2-.1h1l.1.1.1.1h.2s.1 0 .1.1c0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.2.1.1.1.2.2.3s.2.3.3.4c0 .1.1.2.1.3s.1.1.1.2 0 .1.1.2c0 0 0 .1.1.1 0 0 0 .1.1.1 0 .1 0 .1.1.2 0 0 0 .1.1.2 0 0 0 .1.1.2 0 .1 0 .1.1.2v1.7c-.3-.2-.3-.2-.3-.1",
    className: "filialen_svg__st16"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m148 216.8.1-.1s-.1 0-.1.1",
    className: "filialen_svg__st24"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m164.9 209.5-1.9 1.1-18-7 1.9-1.1z",
    className: "filialen_svg__st12"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m146.7 202.2-1.9 1.1v-.2l1-2.6 1.3.5-.4 1zs-.1-.1 0 0q-.15-.15 0 0 0-.15 0 0c0-.1 0 0 0 0",
    className: "filialen_svg__st11"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m147.7 195.5-1.9 1.1-4.8-11.1 2.8 1.2z",
    className: "filialen_svg__st44"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m139 175.6-1.9 1.1-5.1-2 1.9-1.1z",
    className: "filialen_svg__st12"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m140.9 180-1.9 1.1-1.9-4.4 1.9-1.1z",
    className: "filialen_svg__st44"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M164.3 220.8v1c0 .1 0 .1-.1.2 0 .1-.1.1-.1.2s-.1.1-.1.2c-.1.2-.3.4-.5.5-.5.3-1.1.3-1.8.1-.2-.1-.3-.1-.5-.2-1.5-.9-2.8-2.9-3.1-4.8-.2-1.3.2-2.2.9-2.6h.1s.1 0 .1-.1c.1 0 .1 0 .2-.1h1.2s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1c.1.1.2.1.2.2l.2.2v.1l.1.1.1.1c.1.1.1.2.2.3s.1.1.1.2c.1.1.2.3.3.4 0 .1.1.2.1.3 0 0 0 .1.1.1 0 .1.1.2.1.2s0 .1.1.1c0 .1.1.1.1.2s0 .1.1.1c0 .1 0 .1.1.2 0 0 0 .1.1.2 0 .1 0 .1.1.2v1.6c.6-.3.6-.2.6-.2",
    className: "filialen_svg__st20"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M159.2 215.1c-.1 0-.1.1-.2.1l.1-.1zM162.4 214q-.15 0 0 0M162.5 214h-.1zM162.6 214.1h-.1zM162.7 214.1h-.1zM162.9 214.2l-.1-.1c0 .1 0 .1.1.1M161.8 215.8l-.1-.1s0 .1.1.1",
    className: "filialen_svg__st24"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m158.1 199.5-.7 1.6-11.6-4.5 1.9-1.1z",
    className: "filialen_svg__st12"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m165.4 213.4-1.9 1.1-.4-3.9 1.8-1.1z",
    className: "filialen_svg__st44"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m165.1 190.3-1.9 1.1-.1-.1s0-.1-.1-.1c0-.1-.1-.1-.1-.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1h-.3l-22.9-9 1.9-1.1 22.9 9h.6l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1s0 .1.1.1l.1.1c-.2-.1-.2 0-.2.1",
    className: "filialen_svg__st12"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M165.6 191.7v.7l-4 10.3s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.4-.5.5l-1.8 1.1h.1l.1-.1.1-.1.1-.1.2-.2s.1-.1.1-.2c0 0 0-.1.1-.1l4-10.3v-2.3s0-.1-.1-.1l1.9-1.1s0 .1.1.1v1.5c-.2 0-.2 0-.2.1",
    className: "filialen_svg__st11"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M163.7 192.8q0-.15 0 0v-1s0-.1-.1-.1c0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1l-.1-.1s0-.1-.1-.1c0-.1-.1-.1-.1-.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1l-.1-.1-.1-.1s-.1 0-.1-.1l-.1-.1-.1-.1h-.3l-22.9-9-1.9-4.4-5.1-2 .5 3.8 3.1 1.2 7.4 16.8-1.5 3.9c-.2.4-.2 1-.1 1.7.2 1.9 1.6 3.9 3.1 4.8.2.1.3.2.5.2l1.9.7h.1l.1.1.1.1h.1l15 5.9.3.1.1.1.1.1.7.3-.5-3.8-18-7v-.2l1-2.6 1.3.5 10.2 4c.7.3 1.3.2 1.8-.1h.1l.1-.1.1-.1.1-.1.2-.2s.1-.1.1-.2c0 0 0-.1.1-.1l4-10.3v-.6zm-5.6 6.7-.6 1.6-11.6-4.5-4.9-11 2.9 1.1 16.7 6.5z",
    className: "filialen_svg__st20"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M166.2 219.6v.9c0 .1 0 .1-.1.2 0 .1 0 .1-.1.2 0 .1-.1.1-.1.2-.1.2-.3.4-.5.5l-1.8 1.1c.2-.1.4-.3.5-.5 0-.1.1-.1.1-.2 0 0 0-.1.1-.1 0-.1 0-.1.1-.2V219c0-.1 0-.1-.1-.2 0-.1 0-.1-.1-.2 0-.1 0-.1-.1-.2 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1 0-.1-.1-.2v-.1s0-.1-.1-.1c0-.1-.1-.2-.1-.3-.1-.1-.2-.3-.3-.4 0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2l-.1-.1c0-.1-.1-.1-.1-.1v-.1s0-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1h-1.2c-.1 0-.1 0-.2.1 0 0-.1 0-.1.1l1.8-1c.1 0 .2-.1.2-.1.1 0 .1 0 .2-.1h1.1l.1.1.1.1s.1 0 .1.1c0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1s.1.1.1.2.1.1.1.2c.1.1.1.2.2.3s.2.3.2.4c.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.2 0 .1.1.2c0 0 0 .1.1.1 0 .1 0 .1.1.2 0 0 0 .1.1.2s0 .1.1.2c0 .1 0 .1.1.2v1.6z",
    className: "filialen_svg__st16"
  })));
};
export default SvgFilialen;